import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Maybe, QueryHubspotIntegrationTableColumnsArgs, Scalars } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryHubspotIntegrationTableColumnsArgs;

type TData = Maybe<Array<Scalars['String']>>;

export const useHubspotIntegrationTableColumns = (
  variables: TVariables,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query hubspotIntegrationTableColumns($tableId: ID!) {
      hubspotIntegrationTableColumns(tableId: $tableId)
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useHubspotIntegrationTableColumns', ...buildQueryKey(variables)],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
